import { FetchMyCompanyResponse } from "./types";
import { axiosInstanceWithoutInterceptors } from "../axiosInstance";

export const fetchMyCompany = async (
  token: string,
): Promise<FetchMyCompanyResponse> => {
  const impersonateEmployeeUuid = localStorage.getItem(
    "impersonateEmployeeUuid",
  );

  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
  };

  if (impersonateEmployeeUuid) {
    headers["X-Impersonate-Employee-UUID"] = impersonateEmployeeUuid;
    console.log(`Impersonating employee: ${impersonateEmployeeUuid}`);
  }

  const response =
    await axiosInstanceWithoutInterceptors.get<FetchMyCompanyResponse>(
      "/api/private/my-company",
      {
        headers,
      },
    );
  return response.data;
};
